import React, {memo, useCallback, useMemo, useState} from "react";
import "./search.css";

import {Button, Input, InputProps,} from "antd";
import {CloseCircleFilled, SearchOutlined} from "@ant-design/icons";
import {useDebounce} from "../../../services/useDebounce";

interface Props extends InputProps {
  searchLabel?: string;
  value?: string;
  size?: "small" | "middle";
  suffixType?: SuffixType;
  onSearch?: (value: string) => void;
}

const width = {
  small: 218, medium: 234,
}

type SuffixType = 'none' | "clear" | "search";
export const SearchInput = memo(({
                                   size = "small", suffixType, value, onSearch, placeholder = "검색어를 입력해주세요", ...rest
                                 }: Props) => {
  const [inputValue, setInputValue] = useState(value || "");
  
  const debouncedChange = useDebounce((inputValue: string) => {
    !!onSearch && onSearch(inputValue);
  }, 300);
  
  const onHandleChange = (e: any) => {
    setInputValue(e.target.value);
    if (suffixType === "clear") debouncedChange(e.target.value);
  };
  
  const handleSearch = useCallback((event: any) => {
    event.preventDefault();
    !!onSearch && onSearch(inputValue);
  }, [inputValue, onSearch]);
  
  const handleClear = useCallback(() => {
    setInputValue("");
    !!onSearch && onSearch("");
  },[onSearch]);
  
  const suffix = useMemo(() => {
    if (suffixType === 'clear') {
      return (<CloseCircleFilled
        onClick={handleClear}
        style={{color: "rgba(0,0,0,.25)"}}
      />)
    }
    if (suffixType === 'search') {
      return (<SearchOutlined
        onClick={handleSearch}
        style={{color: "rgba(0,0,0,.25)"}}
      />)
    }
    return null;
  }, [handleClear, handleSearch, suffixType])
  
  return (<form
    className={"search"}
    onSubmit={handleSearch}
  >
    <Input
      defaultValue={""}
      autoComplete={"off"}
      size={size}
      style={{width: width[size]}}
      className={"input"}
      onChange={onHandleChange}
      maxLength={30}
      value={inputValue}
      placeholder={placeholder}
      suffix={suffix}
      {...rest}
    />
    {size === "middle" && <Button
        data-cy="searchHomeInput"
        className={"button"}
        size={"small"}
        onClick={handleSearch}
        icon={<SearchOutlined
          style={{color: "rgba(0,0,0,.25)"}}
        />}
    ></Button>}
  </form>);
});
